import { z } from 'zod';

export const CreateBedSchema = z.object({
  bedNumber: z.string().min(1, 'Bed number is required').regex(/^[A-Z]?\d{2,4}$/, 'Bed number format: A101 or 101'),
  room: z.string().min(1, 'Room is required').max(50),
  rentAmount: z.number().min(1000, 'Rent must be at least ₹1000').max(50000, 'Rent cannot exceed ₹50,000'),
  buildingSection: z.string().regex(/^[A-Z]$/).optional(),
  bedType: z.enum(['SINGLE', 'SHARED', 'PREMIUM']).optional(),
});

export type CreateBedInput = z.infer<typeof CreateBedSchema>;
